// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-form-div[data-v-4a1afa03]{padding:20px}.svg-board[data-v-4a1afa03]{display:flex;align-items:center;justify-content:center;border:1px solid #e4e7ed;margin-top:20px;padding:20px 0;height:160px}.svg-board>svg[data-v-4a1afa03]{height:100%!important}.form-bottom[data-v-4a1afa03]{text-align:center;padding-top:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
